module.exports = __webpack_public_path__ + "0aeca8b09888accfccf11976b34c4e64.gif";